declare global {
  interface Window {
    preCheckout?: string;
  }
}

/**
 * @deprecated
 *
 * A place to access windows variables (and potentially handle transforms/typecasting)
 *
 * Deprecated: Fetch data from API. This should not be used for new features.
 */
export const windowVars = {
  isPrecheckout: () => {
    if (window.preCheckout === undefined) return false;
    return !!parseInt(window.preCheckout);
  },

  getOrigin: () => {
    return window.location.origin;
  },
} as const;
